module.exports = __webpack_public_path__ + "img/swiper4.b8471b56.png";